import { render, staticRenderFns } from "./EffectManagement.vue?vue&type=template&id=360582d3&scoped=true"
import script from "./EffectManagement.vue?vue&type=script&lang=js"
export * from "./EffectManagement.vue?vue&type=script&lang=js"
import style0 from "./EffectManagement.vue?vue&type=style&index=0&id=360582d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360582d3",
  null
  
)

export default component.exports